module.exports = __webpack_public_path__ + "static/media/IELTS-Listening-GapFill.a54dbc94.png";